<template>
  <el-dialog :title="titleList[popType]" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="推送方式：" prop="pushMethod" class="width100">
        <el-select v-model="form.pushMethod" placeholder="请选择奖推送方式" clearable size="mini">
            <el-option label="全部" :value="1"></el-option>
            <el-option label="站内推送" :value="2"></el-option>
            <el-option label="App窗口推送" :value="3"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="推送标题：" prop="pushTitle" class="width100">
        <el-input v-model="form.pushTitle" placeholder="请输入推送标题" maxlength="25" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="推送内容：" prop="pushContent" class="width100">
        <el-input type="textarea" v-model="form.pushContent" placeholder="请输入推送内容" maxlength="32" show-word-limit size="medium" rows="6" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="推送用户：" prop="pushUserType" class="width100">
        <el-select v-model="form.pushUserType" placeholder="请选择推送用户" clearable size="mini" @change="changeEv">
            <el-option label="全部" :value="1"></el-option>
            <el-option label="指定用户" :value="2"></el-option>
            <el-option label="体验班用户" :value="3"></el-option>
            <el-option label="研修班用户" :value="4"></el-option>
            <el-option label="普通用户" :value="5"></el-option>
            <el-option label="业务线人员" :value="6"></el-option>
            <el-option label="技术线人员" :value="7"></el-option>
            <el-option label="内部员工" :value="8"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="指定用户：" prop="appointUserIdStr" class="width100" v-if="form.pushUserType==2">
        <el-select 
          v-model="form.appointUserIdStr" 
          placeholder="请输入姓名/手机号搜索" 
          multiple 
          clearable 
          size="mini"
          filterable
          :filter-method="userFilter"
          :loading="userLoading"
        >
          <el-option 
            :label="`${item.userRealName || ''} ${item.userMobile || ''}`" 
            :value="item.userId" 
            v-for="(item,index) in customers" 
            :key="index"
          >
            <span style="font-weight: 500;">{{ item.userRealName ||item.userName|| '' }}</span>
            <span style="font-size: 13px; margin-left: 12px;">{{ item.userMobile || '' }}</span>
            <span style=" font-size: 13px; margin-left: 12px;">{{ item.userLevelName || '' }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        发送
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysNoticeApi from '@/api/system/sysNotice'
import sysToolsApi from '@/api/sys/tools'
function initFormBean() {
  const formBean = {
    pushMethod: '',
    pushTitle: '',
    pushContent: '',
    pushUserType: '',
    appointUserId: '',
    appointUserIdStr: '',
    appointUserPho: '',
    errorMsg: '',
    redUserId: ''
  }
  return formBean
}

export default {
  props: ['popType'],
  //popType 0:新增 1:编辑
  data() {
    return {
      titleList:['新建消息','编辑消息'],
      form: initFormBean(),
      formVisible: false,
      formRules: {
        pushTitle: [{ required: true, message: '请输入推送标题', trigger: 'blur' }],
        pushMethod: [{ required: true, message: '请选择推送方式', trigger: 'change' }],
        pushUserType: [{ required: true, message: '请选择推送用户', trigger: 'change' }],
        pushContent: [{ required: true, message: '请输入推送内容', trigger: 'blur' }]
      },
      customers: [],
      allCustomers: [], // 保存完整的用户数据
      userLoading: false,
      query: {
        pageNo: 1,
        pageSize: 100
      }
    }
  },
  created() {
    this.getCustomer();
  },
  methods: {
    /**
     * 获取客户列表
     */
    async getCustomer(keywords = '') {
      try {
        this.userLoading = true;
        // 使用统一的用户信息列表接口获取用户列表
        const res = await sysToolsApi.userInfoList({
          keywords: keywords,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize
        }).catch(() => ({ data: { list: [], total: 0 } }))
        
        // 保存完整的用户数据
        const userList = (res.data && res.data.list) || [];
        
        if(this.query.pageNo == 1 || keywords) {
          this.customers = userList;
          this.allCustomers = userList;
        } else {
          this.customers = this.customers.concat(userList);
          this.allCustomers = this.allCustomers.concat(userList);
        }
        
        // // 如果还有更多数据，继续获取
        // if(res.data && res.data.total > this.customers.length) {
        //   this.query.pageNo++;
        //   setTimeout(() => {
        //     this.getCustomer();
        //   }, 1000);
        // }
      } catch (error) {
       
        this.customers = [];
        this.allCustomers = [];
      } finally {
        this.userLoading = false;
      }
    },
    /**
     * 用户搜索过滤
     */
    userFilter(keywords) {
      if (!keywords) {
        this.customers = this.allCustomers;
        return;
      }
      // 调用接口进行搜索
      this.query.pageNo = 1;
      this.getCustomer(keywords);
    },
    /**
     * 选择推送用户
     */
     changeEv() {
      if(this.form.pushUserType==2){
        this.formRules.appointUserIdStr = [{ required: true, message: '请选择指定用户', trigger: 'change' }];
      }else {
        this.formRules.appointUserIdStr = [{ required: false, message: '请选择指定用户', trigger: 'change' }];
        this.form.appointUserIdStr = ''
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form.pageNo = 1
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(data) {
      this.resetForm()
      this.form = { ...data.row }
      if(this.form.rewardType==3) this.form.rewardType = '';
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 提交表单
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
            appointUserId: '',
            appointUserPho: '',
            errorMsg: '',
            redUserId: ''
          };
          if(this.form.pushUserType==2) {
            params.appointUserIdStr = this.form.appointUserIdStr.join(',')
          }
          if(this.form.rewardType=='') params.rewardType = 3;
          if (this.form.id > 0) {
            sysNoticeApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            sysNoticeApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    /**
     * 回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }
  .reward-type {
    display: flex;
    &>.el-select {
      &:first-child {
        width: 180px;
        margin-right: 10px;
      }
    }
  }
  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-cascader {
    width: 100%;
  }
</style>
